import Vue from 'vue'

export default {
	/**
	 * Edit a cell by clicking into it.
	 *
	 * @param object event
	 * @param int    index
	 * @param string column
	 *
	 * @return void
	 */
	editCell(event, index, column, dailyData) {
		if (this.editingDisabled || dailyData.locked) return;

		let parent = $(event.target).is('td') ? $(event.target) : $(event.target).parent('td');

		this.editing = {
			status: true,
			index,
			column
		};

		Vue.nextTick(() => {
			parent.find('input').focus();

			// Bind a click event to the document. If the clicked target is the input then we won't
			// leave the cell, however, if they click anywhere else then we'll disable editing
			// and we'll also unbind this event so we don't end up with a bunch of them on
			// the document.
			$(document).on('click.leaveCell', documentEvent => {
				if ($(documentEvent.target).is(parent.find('input'))) return;

				$(document).off('click.leaveCell');

				// when editing a row action we shouldn't lost index information
				if (!this.isEditingAction) {
					this.editing.status = false;
					this.editing.index = null;
				}
			});
		});
	},

	/**
	 * Tab to the next or previous cell.
	 *
	 * @param object event
	 * @param int    index
	 * @param string next
	 * @param string previous
	 *
	 * @return void
	 */
	tabToNextCell(event, index, next, previous, data) {
		event.preventDefault();

		let row = $(event.target).closest('tr'),
			nextRow = row;

		if (event.shiftKey) {
			// If the shift key is pressed and the previous column is comments then they
			// are tabbing back up one row so we change the parent and adjust the index.
			if (previous == 'comments') {
				nextRow = nextRow.prev('tr');

				index--;
			}
		} else {
			// Likewise, if they are tabbing forwards and the next column is baume then
			// they are going down to the next row. Or if we aren't showing the baume
			// column and the next column is temperature then we are tabbing down
			// to the next row.
			if (next == 'baume' || (! this.allowBaume && next == 'temp')) {
				nextRow = nextRow.next('tr');

				index++;
			}
		}

		if (data.locked) {
			return
		}

		// If the next row length is zero then we have most likely tabbed down to a blank
		// row that does not yet exist, so we'll push a new row onto the end.
		if (nextRow.length == 0) {
			this.handleTabToBlankRow(event, index, previous, next);
		} else {
			this.editing = {
				status: true,
				index,
				column: event.shiftKey ? previous : next
			};
		}

		Vue.nextTick(() => {
			if (nextRow.length == 0) {
				nextRow = this.findNextRow(row);
			}

			nextRow = nextRow.find(`td.${this.editing.column}`);

			nextRow.find('input').focus();
		});
	},
}



// WEBPACK FOOTER //
// ./src/components/ferment/daily-data/tabbing.js